import { GetterTree } from 'vuex'
import { PreprocessingRulesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<PreprocessingRulesState, RootState> = {
  preprocessingRules: state => state.preprocessingRules,

};